import ConfirmationDialog from '@rio-cloud/rio-uikit/ConfirmationDialog';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDeleteServiceProviderClientMutation } from '../api/serviceProviderApi';
import { handleQueryError } from '../notifications/ErrorNotification';
import { showSuccessNotification } from '../notifications/SuccessNotification';
import { ConfirmButtonText } from '../sharedComponents/ConfirmButtonText';
import { ServiceProvider } from './serviceProvider.types';
import { runInBackgroundCallback } from '../../../configuration/setup/backgroundActions';

type DeleteClientConfirmationProps = {
    serviceProvider: ServiceProvider;
    show: boolean;
    setShow: (value: boolean) => void;
};

export const DeleteClientConfirmation: FunctionComponent<DeleteClientConfirmationProps> = ({
    serviceProvider,
    show,
    setShow,
}) => {
    const [deleteClient, deleteClientRequest] = useDeleteServiceProviderClientMutation();

    const { serviceProviderName, accountId, interfaceClient } = serviceProvider;

    const handleOnClick = runInBackgroundCallback(async () => {
        setShow(false);
        await deleteClient({ accountId, clientId: interfaceClient!.clientId })
            .unwrap()
            .then(() => showSuccessNotification('outboundOrderBook.serviceProviders.deleteClient.success'))
            .catch(handleQueryError);
    });

    return (
        <ConfirmationDialog
            show={show}
            title={<FormattedMessage id="outboundOrderBook.serviceProviders.deleteClient.title" />}
            content={
                <div>
                    <FormattedMessage
                        id="outboundOrderBook.serviceProviders.deleteClient.text"
                        values={{
                            serviceProviderName: <strong>{serviceProviderName}</strong>,
                        }}
                    />
                </div>
            }
            bsSize={Dialog.SIZE_SM}
            onClickConfirm={handleOnClick}
            onClickCancel={() => setShow(false)}
            cancelButtonText={<FormattedMessage id="outboundOrderBook.common.button.cancel" />}
            confirmButtonText={
                <ConfirmButtonText
                    showSpinner={deleteClientRequest.isLoading}
                    labelId="outboundOrderBook.serviceProviders.button.deleteClient"
                />
            }
            useOverflow
        />
    );
};
